import React from 'react';
import { Pagination } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../../assets/css/Pagination.css';

const PaginationComponent = ({ currentPage, lastPage, onPageChange, disabled }) => {
  const pages = [];
  for (let i = 1; i <= lastPage; i++) {
    pages.push(i);
  }

  return (
    <Pagination className="justify-content-center overflow-auto mt-4">
      <Pagination.First disabled={disabled || currentPage === 1} onClick={() => onPageChange(1)} />
      <Pagination.Prev disabled={disabled || currentPage === 1} onClick={() => onPageChange(currentPage - 1)} >
        <FaChevronLeft />
      </Pagination.Prev>
      {pages.map(page => (
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => onPageChange(page)}
          disabled={disabled}
        >
          {page}
        </Pagination.Item>
      ))}
      <Pagination.Next disabled={disabled || currentPage === lastPage} onClick={() => onPageChange(currentPage + 1)} >
        <FaChevronRight />
      </Pagination.Next>
      <Pagination.Last disabled={disabled || currentPage === lastPage} onClick={() => onPageChange(lastPage)} />
    </Pagination>
  );
};

export default PaginationComponent;